module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3cfc9b39a0d002246119d47f6756d77e.svg";